var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leftArea"},[_c('Echart',{ref:"centreLeft1ChartRef",attrs:{"id":"centreLeft1Chart","options":_vm.options,"height":"990px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }